import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation, Pagination, Thumbs } from "swiper/modules";

export const initSwiperInstance = () => {
	Swiper.use([Navigation, Pagination, Thumbs, Autoplay, FreeMode]);
	window.Swiper = Swiper;
};
